import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

interface Flight {
    "company name": string;
    date: string;
    price: number;
    destination: string;
}

interface PricePerDestProps {
    flightsData: Flight[];
    elAlData: Flight[];
}

enum Airlines {
    EL_AL = "El Al Israel",
    OTHER = "Other Airlines"
}

const PricePerDest: React.FC<PricePerDestProps> = ({ flightsData,elAlData }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const chartInstanceRef = useRef<Chart | null>(null);

    useEffect(() => {
        if (chartInstanceRef.current) {
            chartInstanceRef.current.destroy();
        }


        const destinations:any = {};

        elAlData.forEach(flight => {
            if (!destinations[flight.destination]) {
                destinations[flight.destination] = [];
            }
            destinations[flight.destination].push(flight.price);
        });

        const labels = Object.keys(destinations);
        const prices = labels.map(destination => {
            const total = destinations[destination].reduce((sum: number, price: number) => sum + price, 0);
            return total / destinations[destination].length;
        });

        // Fetch the JSON data for the second dataset

        const elAlDestinations: any = {};

        flightsData.forEach(flight => {
            if (!elAlDestinations[flight.destination]) {
                elAlDestinations[flight.destination] = [];
            }
            elAlDestinations[flight.destination].push(flight.price);
        });

        const elAlPrices = labels.map(destination => {
            const total = elAlDestinations[destination].reduce((sum: number, price: number) => sum + price, 0);
            return total / elAlDestinations[destination].length;
        });

        // @ts-ignore
        const ctx = canvasRef.current.getContext('2d');

        // @ts-ignore
        new Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [
                    {
                        label: 'Average Market Price',
                        data: prices,
                        backgroundColor: '#2f5e9299',
                        borderColor: 'rgba(1,62,128,0.6)',
                        borderWidth: 1
                    },
                    {
                        label: 'Average Client Price',
                        data: elAlPrices,
                        backgroundColor: '#ffac26',
                        borderColor: 'rgba(255,158,3,0.61)',
                        borderWidth: 1
                    }
                ]
            },
            options: {
                plugins: {
                  title: {
                        display: true,
                        text: 'Flight price by destination-city- client vs Market',
                        font: {
                            size: 20
                        },
                        padding: {
                            top: 20,
                            bottom: 30
                        }
                    },
                  
                },
                scales: {
                    y: {
                        beginAtZero: true
                    }
                }
            }
        });

        return () => {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
        };
    }, [flightsData]);

    return (
        <div>
            <canvas ref={canvasRef} width="800" height="800"></canvas>
        </div>
    );
};

export default PricePerDest;
